module.exports = ".preloader {\n  background: #FFF; }\n"